'use client';
import React, { useState } from 'react';
import GuestTopbar from '@/components/GuestTopbar';
import GuestFooter from '@/components/GuestFooter';
import HeroSearch from './components/HeroSearch';
import ApartmentGrid from './components/ApartmentGrid';
import TrustSection from './components/TrustSection';
import TestimonialsStrip from './components/TestimonialsStrip';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [guests, setGuests] = useState('2');

  return (
    <div className="min-h-screen bg-background">
      <GuestTopbar />
      <main>
        <HeroSearch
          checkIn={checkIn}
          checkOut={checkOut}
          guests={guests}
          onCheckInChange={setCheckIn}
          onCheckOutChange={setCheckOut}
          onGuestsChange={setGuests}
        />
        <ApartmentGrid checkIn={checkIn} checkOut={checkOut} guests={guests} />
        <TrustSection />
        <TestimonialsStrip />
        <ContactSection />
      </main>
      <GuestFooter />
    </div>
  );
}